import ENDPOINTS from '@utils/apiEndpoints';
import { axiosInstance } from '@utils/axiosInstance';
import { onApiError, onApiSuccess } from '@utils/utilities';

export const userCustomerDeliveryFileAuthService = (key, data: any) => {
  return axiosInstance
    .post(
      `${ENDPOINTS.USER.DOWNLOAD_FILE.CUSTOMER_DELIVERY.FILE_AUTH}/${key}`,
      data,
    )
    .then((response) => {
      return onApiSuccess(response);
    })
    .catch((error) => {
      return onApiError(error);
    });
};
